// extracted by mini-css-extract-plugin
export default {"modal-header":"modal-header-DVPnCCs","header-content":"header-content-FQ5Kz8j","close-button":"close-button-fIIgmXH"};